export const CREATE_FEED_MESSAGE = "CREATE_FEED_MESSAGE";
export const UPDATE_FEED_MESSAGE = "UPDATE_FEED_MESSAGE";
export const DELETE_FEED_MESSAGE = "DELETE_FEED_MESSAGE";
